/*
 * Countdown — Beam LP family.
 *
 * Drives every [data-lp-countdown] on the page from its own data-ends-at
 * (an ISO 8601 string with an explicit offset, e.g. 2026-08-31T23:59:59-05:00).
 * A landing page normally has several of these — announcement bar, hero note,
 * buy box badge, guarantee badge, sticky bar — each carrying the same date, so
 * they are collected once and updated from a single interval.
 *
 * Document-wide + guarded so it runs once no matter how many sections load it.
 *
 * The server renders a placeholder ("--d --:--:--") rather than a computed
 * value: Liquid renders at cache time, so a server-computed countdown would be
 * stale the moment the page is served from cache.
 */
(function () {
  if (window.__lpCountdown) return;
  window.__lpCountdown = true;

  function pad(n) {
    return String(n).padStart(2, "0");
  }

  function format(msLeft) {
    var left = msLeft;
    var d = Math.floor(left / 864e5);
    left -= d * 864e5;
    var h = Math.floor(left / 36e5);
    left -= h * 36e5;
    var m = Math.floor(left / 6e4);
    left -= m * 6e4;
    var s = Math.floor(left / 1e3);
    return d + "d " + pad(h) + ":" + pad(m) + ":" + pad(s);
  }

  function init() {
    var nodes = [].slice.call(document.querySelectorAll("[data-lp-countdown]"));
    if (!nodes.length) return;

    var timers = nodes
      .map(function (el) {
        var ends = Date.parse(el.dataset.endsAt);
        // A malformed or missing date would otherwise render "NaNd NaN:NaN:NaN"
        // on a live page; fall back to the ended text and stop.
        if (isNaN(ends)) {
          el.textContent = el.dataset.endedText || "";
          return null;
        }
        return { el: el, ends: ends, ended: false };
      })
      .filter(Boolean);

    if (!timers.length) return;

    function tick() {
      var now = Date.now();
      var live = 0;
      timers.forEach(function (t) {
        if (t.ended) return;
        var left = t.ends - now;
        if (left <= 0) {
          t.el.textContent = t.el.dataset.endedText || "OFFER ENDED";
          t.ended = true;
          return;
        }
        t.el.textContent = format(left);
        live++;
      });
      if (!live && interval) clearInterval(interval);
    }

    tick();
    var interval = setInterval(tick, 1000);
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
})();
